export default __webpack_public_path__ + "static/media/DK-Logo-2020-white.a6eb7e8f.svg";